import './PuzzleMenu.css';

import React from 'react';
import {Link} from 'react-router-dom';

const puzzles = ['geral','causa','sintomas','transmissao','prevencao','vacinas'];

function PuzzleMenu(){

  let imageDevice = (false)?'_mobile':'';

  return(
    <div className="PuzzleMenu row wrap spaceAroundContent">
      {puzzles.map((puzzle, index) =>
        <div key={index} className="buttonsPuzzle">
          <Link key={index} className="link" to={"/game/"+puzzle}>
            <img key={index} className="buttonPuzzle shadow" src={'/app/infocovidmais/images/layout/menuPuzzle/'+puzzle+imageDevice+'.png'}  alt={puzzle}/>
          </Link>
        </div>
      )}
    </div>
  );
}

export default PuzzleMenu;
